import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  n: '1',
  title: 'Instant download',
  desc: 'Purchase and get immediate access to the complete 6-volume digital book and all 5 bonuses. Start whenever you want, no waiting.'
}, {
  n: '2',
  title: 'Assess and load progressively',
  desc: 'Identify the severity of your strain, unlock the muscle without damage and apply load using the criteria of each phase. The system is your roadmap.'
}, {
  n: '3',
  title: 'Return to action and shield it',
  desc: 'Bridge the gap between rehab and real life — running, jumping, lifting — then lock in the weekly Shield routines so the injury never returns.'
}];
export function Steps() {
  return <section aria-label="How it works" className="bg-transparent" data-id="element-158" data-mp="fpxq6u1l8o1e">
      <div className="mx-auto max-w-4xl px-5 py-12" style={{
      paddingTop: "12px",
      paddingBottom: "17px"
    }} data-id="element-159" data-mp="261ljaqie5d4p">
        <h2 className="text-center font-display text-2xl font-black text-plum sm:text-3xl" data-id="element-160" data-mp="2a2faptv1la2c">
          How You'll Progress Starting Today
        </h2>
        <p className="mt-3 text-center text-sm text-plum/60" data-id="element-161" data-mp="1q8zjj18gromm">In just 3 simple steps</p>

        <ol className="mt-10 space-y-4" data-id="element-162" data-mp="1la6dftviazwh">
          {steps.map((s, i) => <motion.li key={s.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-start gap-4 rounded-2xl border border-grape/15 bg-white p-5" data-id="element-163" data-mp="1zzu3u025ge5f" data-mpi={i}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-grape font-display text-base font-black text-white" data-id="element-164" data-mp="1hb71hpbcy2vj">
                {s.n}
              </span>
              <div data-id="element-165" data-mp="2spkn0nin268e">
                <h3 className="text-base font-bold text-plum" data-id="element-166" data-mp="2sorlq22g88xn">{s.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-plum/65" data-id="element-167" data-mp="2nqzs93m5oerc">{s.desc}</p>
              </div>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}